import gql from 'graphql-tag';
const A_SENTENCES_WPM_ACTIVITY_FRAGMENT = gql `
  fragment ASentencesWpmActivityFragment on ASentencesWpmActivity {
    rounds {
      activitySentences: sentences
    }
  }
`;
export default A_SENTENCES_WPM_ACTIVITY_FRAGMENT;
